import { NodeManager, DEFAULT_CATEGORY_CONFIG } from '@/components/flow/services/nodeManager'
export type { NodeRegistry, CategoryConfigEntry } from '@/components/flow/services/nodeManager'

export interface SetupMFlowOptions {
  extraNodes?: Record<string, import('@/components/flow/services/nodeManager').NodeRegistry>
  categories?: import('@/components/flow/services/nodeManager').CategoryConfigEntry[]
  reset?: boolean
  includeDefaultNodes?: boolean
}

export function setupMFlow(options?: SetupMFlowOptions) {
  const manager = NodeManager.getInstance()
  if (options?.reset !== false) {
    manager.reset()
  }
  if (options?.includeDefaultNodes !== false) {
    manager.initDefaultNodes()
  }
  if (options?.extraNodes) {
    manager.registerMultiple(options.extraNodes)
  }
  manager.setCategories(options?.categories ?? DEFAULT_CATEGORY_CONFIG)
  return manager
}

export { NodeManager, DEFAULT_CATEGORY_CONFIG }